import styles from '@jobcase/react_pattern_library/styles/rebrand';

export const TABS = {
  JOBS: 'jobs',
};

export const TABS_TITLES = {
  jobs: 'Jobs',
};

export const CLICKS_CANDIDATES_DROPDOWN_OPTIONS = {
  click_count: { key: 'click_count', title: 'Clicks' },
  candidate_count: { key: 'candidate_count', title: 'Candidates' },
};

export const SPENDING_JOBS_DROPDOWN_OPTIONS = {
  total_spending: { key: 'total_spending', title: 'Spend' },
  job_count: { key: 'job_count', title: 'Job Count' },
};

export const ALL_JOBS_SORT_OPTIONS = [
  {
    label: 'Job title A-Z',
    value: 'title&false',
  },
  {
    label: 'Job title Z-A',
    value: 'title&true',
  },
  {
    label: 'Newest created',
    value: 'date_created&true',
  },
  {
    label: 'Oldest created',
    value: 'date_created&false',
  },
  // TODO: Add after total_spend is returned by API
  // {
  //   label: 'Most spent',
  //   value: 'spent&true',
  // },
  // {
  //   label: 'Fewest spent',
  //   value: 'spent&false',
  // },
  {
    label: 'Most clicks',
    value: 'clicks&true',
  },
  {
    label: 'Fewest clicks',
    value: 'clicks&false',
  },
  {
    label: 'Most candidates',
    value: 'candidates&true',
  },
  {
    label: 'Fewest candidates',
    value: 'candidates&false',
  },
];

export const JOBS_PER_PAGE_DROPDOWN_VALUES = ['5', '10', '15', '20'];

export const JOBS_TABLE_HEADINGS = [
  {
    title: 'Job title',
  },
  {
    title: 'Creation date',
    tooltipText: 'The date and time the job posting was created',
  },
  // TODO: Add after total_spend is returned by API
  // {
  //   title: 'Total spending',
  //   tooltipText: 'Total amount spent on sponsorship for this job posting',
  // },
  {
    title: 'Clicks',
    tooltipText: 'Number of times users have clicked on the job posting',
  },
  {
    title: 'Candidates',
    tooltipText: 'Number of jobseekers that have applied',
  },
];

export const ALL_JOBS_QUERY_PARAMS = {
  DASHBOARD_ALL_JOBS_SORT: 'dbajs',
  DASHBOARD_ALL_JOBS_CURRENT_PAGE: 'dbajcp',
  DASHBOARD_ALL_JOBS_JOBS_PER_PAGE: 'dbajjpp',
};

export const BREAKPOINT_FOR_REMOVING_JOBS_TABLE_SCROLL = styles.breakpoint.lg_num + 142;
export const JOB_FILTERS_STEPS = {
  SUB_ORGS: 0,
  JOB_GROUPS: 1,
  JOBS: 2,
};

export const DEFAULT_CARD_HEIGHT = 75;

export default {
  TABS_TITLES,
  TABS,
  ALL_JOBS_SORT_OPTIONS,
  JOBS_PER_PAGE_DROPDOWN_VALUES,
  ALL_JOBS_QUERY_PARAMS,
  BREAKPOINT_FOR_REMOVING_JOBS_TABLE_SCROLL,
  JOB_FILTERS_STEPS,
  DEFAULT_CARD_HEIGHT,
};
